import React from 'react';
import Modal from 'react-bootstrap/Modal';
import Button from 'react-bootstrap/Button';


export default function Taketheshoot() {
  const [show, setShow] = React.useState(true);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  
  return (
    <>
      <Button variant="primary" onClick={handleShow}>
        Launch demo modal
      </Button>

      <Modal show={show} onHide={handleClose}>
        <Modal.Header closeButton>
          <Modal.Title>Figyelmeztetés</Modal.Title>
        </Modal.Header>
        <Modal.Body>Elmúltál 18?</Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Igen
          </Button>
          <a target="_self" href="http://google.com">
            <Button variant="primary" onClick={handleClose}>
              Nem
            </Button>
          </a>
        </Modal.Footer>
      </Modal>
    </>
  );
  
    
}